module.exports = __webpack_public_path__ + "img/17859_L.05a7a7ae.png";